"use strict";import{Radio as e}from"./src/Radio.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-radio",e);
//# sourceMappingURL=sp-radio.js.map
